import { useContext } from 'react'
import { UserContext } from '../contexts/UserContext/UserProvider'

export const useUserContext = () => useContext(UserContext)
